<template>
    <div>
        <div class="flex center-xs space-top-1 space-bottom-2">
            <div class="input-container">

                <!-- Desktop layout -->
                <div class="row hidden-m justify-center" v-for="(checkboxRow, index) in chunkedCheckboxes" :key="index">
                    <div class="vertical-checkbox-space" v-for="(checkbox, index) in checkboxRow" :key="index">
                        <input v-model="inputData" class="hidden" type="checkbox" :value="checkbox.value" :id="checkbox.value">
                        <label @keyup.enter="keycheck" class="checkbox-label" :for="checkbox.value" tabindex="0">
                            <div class="checkbox-desktop checkbox-unselected flex center-xs">
                                <img :src="checkbox.unselectedSrc" :alt="checkbox.unselectedAlt" width="70">
                                <div class="checkbox-text">{{checkbox.value}}</div>
                                <div class="valid-checkbox valid-checkbox-gray"></div>
                            </div>
                            <div class="checkbox-desktop checkbox-selected flex center-xs">
                                <img :src="checkbox.selectedSrc" :alt="checkbox.selectedAlt" width="70">
                                <div class="checkbox-text">{{checkbox.value}}</div>
                                <div class="valid-checkbox valid-checkbox-blue"></div>
                                <div class="valid-checkmark"></div>
                            </div>
                        </label>
                    </div>
                </div>

                <!-- Mobile Layout -->
                <div class="visible-m">
                    <div class="row vertical-checkbox-space" v-for="(checkbox, index) in consolidatedCheckboxes" :key="index">
                        <input v-model="inputData" class="hidden" type="checkbox" :value="checkbox.value" :id="checkbox.value + '-m'">
                        <label class="checkbox-label" :for="checkbox.value + '-m'">
                            <div class="mobile-checkbox">
                                <div class="checkbox-text">{{checkbox.value}}</div>
                                <div class="valid-checkbox valid-checkbox-gray"></div>
                                <div class="valid-checkbox valid-checkbox-blue"></div>
                                <div class="valid-checkmark"></div>
                            </div>
                        </label>
                    </div>
                </div>

                <div v-if="diplayErrorMessage" class="red-text space-top-2">{{step.errorMessage}}</div>
            </div>
        </div>

        <ButtonSection
          :inputValid="inputValid"
          :order="order"
          :buttonText="step.buttonText"
          v-on:progress="handleProgress"
          v-on:back="$emit('back')"
        />
    </div>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';

import ButtonSection from '../components/ButtonSection';

export default {
    props: ['step', 'order'],
    components: {
        ButtonSection
    },
    data() {
        return {
            smallDesktopGridWidth: 2,
            standardDesktopGridWidth: 3,
            dirty: false
        }
    },
    validations: {
        inputData: {
            required,
            minLength: minLength(1)
        }
    },
    computed: {
        inputData: {
            get () {
                return this.$store.state.formFields[this.step.name];
            },
            set (value) {
                this.dirty = true;
                const name = this.step.name;
                this.$store.commit('updateField', { name, value })
            }
        },
        inputValid() {
            return !this.$v.inputData.$invalid;
        },
        diplayErrorMessage() {
            return this.$v.inputData.$invalid && this.dirty;
        },
        chunkedCheckboxes() {
            let checkboxes = [...this.consolidatedCheckboxes];
            let chunkedCheckboxes = [];
            while(checkboxes.length > 0) {
                chunkedCheckboxes.push(checkboxes.splice(0, this.desktopBoxGridType))
            }
            return chunkedCheckboxes;
        },
        consolidatedCheckboxes() {
            const checkboxes = this.step.checkboxImagesUnselected.map(function(_, i) {
                return {
                    'unselectedSrc': this.checkboxImagesUnselected[i].fields.file.url,
                    'unselectedAlt': this.checkboxImagesUnselected[i].fields.description,
                    'selectedSrc': this.checkboxImagesSelected[i].fields.file.url,
                    'selectedAlt': this.checkboxImagesSelected[i].fields.description,
                    'value': this.valueList[i],
                }
            }, this.step);
            return checkboxes;
        },
        desktopBoxGridType() {
            return this.step.checkboxImagesUnselected.length <= 4 ? this.smallDesktopGridWidth : this.standardDesktopGridWidth;
        }
    },
    watch: {
        step: function() {
            // If there are two consecutive Checkbox, make sure dirty is reset
            this.dirty = false;
        }
    },
    methods: {
        handleProgress(){
            this.$emit('progress', this.step.name);
        },
        keycheck(e) {
            if (e.keyCode === 13 && this.inputValid) {
                this.$emit('progress', this.step.name);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.vertical-checkbox-space {
    margin: 10px 0;
}

.valid-checkbox {
    width: 25px;
    height: 25px;
    position: absolute;
    right: 14px;
    top: 16px;

    @media (min-width: 736px) {
        top: 12px;
    }
}

.valid-checkbox-gray {
    display: block;
    border: 1px solid #BCBCBC;
}

.valid-checkbox-blue {
    background: #0384FB;
}

.valid-checkmark {
    width: 25px;
    height: 25px;
    position: absolute;
    right: 10px;
    top: 22px;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='17' height='13' viewBox='0 0 17 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.45299 12.4355C5.14852 12.4355 4.84325 12.3188 4.6107 12.0863L0.380073 7.85645C-0.0850243 7.39135 -0.0850243 6.63697 0.380073 6.17187C0.84517 5.70677 1.59955 5.70677 2.06465 6.17187L5.45299 9.56021L14.1644 0.848823C14.6295 0.383726 15.3839 0.383726 15.849 0.848823C16.3141 1.31392 16.3141 2.06751 15.849 2.5326L6.29528 12.0863C6.06273 12.3188 5.75746 12.4355 5.45299 12.4355Z' fill='white'/%3e%3c/svg%3e ");
    background-repeat: no-repeat;

    @media (min-width: 736px) {
        top: 18px;
    }
}

.checkbox-label {
    outline: none;
    width: 100%;
    height: 60px;
    @media (min-width: 736px) {
        width: 180px;
        height: 132px;
    }
}

.checkbox-desktop {
    width: 180px;
    height: 132px;
    position: relative;
}

.checkbox-text {
    padding-top: 18px;
    @media (min-width: 736px) {
        padding-top: 10px;
    }
}

input[type="checkbox"] + label {
    border: 1px solid #E7E7E7;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    margin: 0px 10px;

    &>.checkbox-unselected {
        -ms-flex-line-pack: center;
        align-content: center;
        display: flex;
        display: -ms-flexbox;
        -webkit-justify-content: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
    }

    &>.checkbox-selected {
        display: none;
    }

    &>.mobile-checkbox {
        &>.valid-checkbox-blue {
            display: none;
        }
        &>.valid-checkmark {
            display: none;
        }
    }
}

input[type="checkbox"]:checked + label {
    border: 3px solid #0384FB;

    &>.checkbox-unselected {
        display: none;
    }

    &>.checkbox-selected {
        -ms-flex-line-pack: center;
        align-content: center;
        display: flex;
        display: -ms-flexbox;
        -webkit-justify-content: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
    }

    &>.mobile-checkbox {
        &>.valid-checkbox-blue {
            display: block;
        }
        &>.valid-checkmark {
            display: block;
        }
        &>.valid-checkbox-gray {
            display: none;
        }
    }
}

.mobile-checkbox {
    width: 100%;
    height: 60px;
    display: block;
    position: relative;
}

.justify-center {
  justify-content: center;
}
</style>